export const cacheKeys = {
  aidDetail: 'aid-detail',
  eadDetail: 'ead-detail',
  collectionDetail: 'collection-detail',
};

export const getCacheKey = (key: keyof typeof cacheKeys, identifier: string) =>
  `${cacheKeys?.[key]}-${identifier}`;
